import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Landing from './components/Landing';
import Cabinet from './components/Cabinet';
import ActivationPage from './components/cabinet/ActivationPage';
import ResetPasswordPage from './components/cabinet/ResetPasswordPage';
import Admin from './components/admin/Admin';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route path="/activate/:hash" component={ActivationPage} />
          <Route path="/reset-password/:hash" component={ResetPasswordPage} />
          <ProtectedRoute path="/cabinet" component={Cabinet} />
          <Route path="/admin" component={Admin} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;

